import { CountryKey } from '@/enums';
import { getRoute } from '@/hooks/useRouteSection';

export const getCountryCode = () => {
  const { countryCode } = getRoute(window.location.pathname);
  if (countryCode === CountryKey.MalaysiaUrl) {
    return CountryKey.MalaysiaCode;
  } else if (countryCode === CountryKey.PhilippinesUrl) {
    return CountryKey.PhilippinesCode;
  }
};
